<script setup name="CookiePolicyContact">
import CookiePolicyTitle from '~/components/CookiePolicyTitle.vue';
</script>

<template>
  <div class="space-y-6">
    <CookiePolicyTitle>Contact</CookiePolicyTitle>
    <p>
      If you need more information, you can contact us by
      <a
        href="mailto:myg2support@g2ocean.com"
        class="text-primary-8"
        target="_blank"
        >myg2support@g2ocean.com</a
      >
    </p>
  </div>
</template>
